import React from "react";

import CustomAutoCompleteFilter from "../../../lib/components/customdatagridfilter/CustomFilter";
import { DateFormatter, FormatterNumber, FormatterNumber2Decimals, FormatterRecon } from "../../../lib/components/Formatters";
import { SummaryTotal, SummaryNumber2Decimal, SummaryNumber } from "../../../lib/components/SummaryFormatter";
import { handleColumnsArrangement, handleColumnsWidth } from "../../../lib/helpers/grid";

const cellWidthTiny = 40;
const cellWidthSmall = 80;
const cellWidthMedium = 100;
const cellWidthLarge = 200;

const defaultColumnProperties = {
  resizable: true,
  sortable: true,
};

let currentSpace = true;
export const GridColumns = (data, filters, arrangement = undefined, columnsWidth = undefined) => {
  let postValue = "";

  if (data) {
    if (currentSpace) {
      postValue = " ";
    }
    currentSpace = !currentSpace;
  }

  const columns = [
    {
      key: "producer_id",
      name: "Producer ID" + postValue,
      width: cellWidthMedium,
      filterable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"producer_id"} data={data} section="producersfullgroupedpmnt" />;
      },
      summaryFormatter: SummaryTotal,
    },
    {
      key: "producer_name",
      name: "Producer Name" + postValue,
      width: cellWidthLarge,
      filterable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"producer_name"} data={data} section="producersfullgroupedpmnt" />;
      },
    },
    // {
    //   key: "bar_CommodityCode",
    //   name: "Commodity" + postValue,
    //   width: cellWidthMedium,
    //   filterable: true,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"bar_CommodityCode"} data={data} section="producersfullgroupedpmnt" />;
    //   },
    // },
    // {
    //   key: "bar_VarietyCode",
    //   name: "Variety" + postValue,
    //   width: cellWidthMedium,
    //   filterable: true,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"bar_VarietyCode"} data={data} section="producersfullgroupedpmnt" />;
    //   },
    // },
    {
      key: "dispatch_currencycode",
      name: "Currency" + postValue,
      width: cellWidthMedium,
      filterable: true,
      filterRenderer: (e) => {
        return (
          <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"dispatch_currencycode"} data={data} section="producersfullgroupedpmnt" />
        );
      },
    },
    {
      key: "wkcolddue_week",
      name: "Cold Due Week" + postValue,
      width: cellWidthMedium,
      filterable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"wkcolddue_week"} data={data} section="producersfullgroupedpmnt" />;
      },
    },
    {
      key: "wkintakedue_week",
      name: "Intake Due Week" + postValue,
      width: cellWidthMedium,
      filterable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"wkintakedue_week"} data={data} section="producersfullgroupedpmnt" />;
      },
    },
    {
      key: "wkshippingdue_week",
      name: "Shipping Due Week" + postValue,
      width: cellWidthMedium,
      filterable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"wkshippingdue_week"} data={data} section="producersfullgroupedpmnt" />;
      },
    },
    {
      key: "bar_PalletSize",
      name: "Total Pallets" + postValue,
      width: cellWidthMedium,
      filterable: true,
      formatter: FormatterNumber2Decimals,
      summaryFormatter: SummaryNumber2Decimal,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"bar_PalletSize"} data={data} section="producersfullgroupedpmnt" />;
      },
    },
    {
      key: "bar_NoCartons",
      name: "Total Cartons" + postValue,
      width: cellWidthMedium,
      filterable: true,
      formatter: FormatterNumber,
      summaryFormatter: SummaryNumber,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"bar_NoCartons"} data={data} section="producersfullgroupedpmnt" />;
      },
    },
    {
      key: "paid_currency",
      name: "Paid CURR" + postValue,
      width: cellWidthMedium,
      filterable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"paid_currency"} data={data} section="producersfullgroupedpmnt" />;
      },
    },
    {
      key: "sum_paidcurrencyValue",
      name: "Total Value" + postValue,
      width: cellWidthMedium,
      filterable: true,
      formatter: FormatterNumber2Decimals,
      summaryFormatter: SummaryNumber2Decimal,
      filterRenderer: (e) => {
        return (
          <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"sum_paidcurrencyValue"} data={data} section="producersfullgroupedpmnt" />
        );
      },
    },
    {
      key: "adhocdetail_remainingamount",
      name: "AD-HOC +/-" + postValue,
      width: cellWidthMedium,
      filterable: true,
      formatter: FormatterNumber2Decimals,
      summaryFormatter: SummaryNumber2Decimal,
      filterRenderer: (e) => {
        return (
          <CustomAutoCompleteFilter
            {...e}
            multiSelection={true}
            currentFilters={filters}
            fieldname={"adhocdetail_remainingamount"}
            data={data}
            section="producersfullgroupedpmnt"
          />
        );
      },
    },
    {
      key: "sum_paidcurrencyValueTotal",
      name: "Paid Total" + postValue,
      width: cellWidthMedium,
      filterable: true,
      formatter: FormatterNumber2Decimals,
      summaryFormatter: SummaryNumber2Decimal,
      filterRenderer: (e) => {
        return (
          <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"sum_paidcurrencyValueTotal"} data={data} section="producersfullgroupedpmnt" />
        );
      },
    },
    {
      key: "produceradvancepaidhead_ident",
      name: "Payment Ident" + postValue,
      width: cellWidthMedium,
      filterable: true,
      formatter: FormatterRecon,
      filterRenderer: (e) => {
        return (
          <CustomAutoCompleteFilter
            {...e}
            multiSelection={true}
            currentFilters={filters}
            fieldname={"produceradvancepaidhead_ident"}
            data={data}
            section="producersfullgroupedpmnt"
          />
        );
      },
    },
    {
      key: "produceradvancepaidhead_makeanote",
      name: "AD-HOC Note" + postValue,
      width: cellWidthLarge,
      filterable: true,
      filterRenderer: (e) => {
        return (
          <CustomAutoCompleteFilter
            {...e}
            multiSelection={true}
            currentFilters={filters}
            fieldname={"produceradvancepaidhead_makeanote"}
            data={data}
            section="producersfullgroupedpmnt"
          />
        );
      },
    },
    {
      key: "produceradvancepaidhead_posteddate",
      name: "Posted Date" + postValue,
      width: cellWidthMedium,
      filterable: true,
      filterRenderer: (e) => {
        return (
          <CustomAutoCompleteFilter
            {...e}
            multiSelection={true}
            currentFilters={filters}
            fieldname={"produceradvancepaidhead_posteddate"}
            data={data}
            section="producersfullgroupedpmnt"
          />
        );
      },
      formatter: DateFormatter,
    },
    {
      key: "paphweek_week",
      name: "Posted Week" + postValue,
      width: cellWidthLarge,
      filterable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"paphweek_week"} data={data} section="producersfullgroupedpmnt" />;
      },
    },
  ].map((c) => ({ ...c, ...defaultColumnProperties }));

  let columnsArranged = [];
  columnsArranged = handleColumnsArrangement(columnsArranged, arrangement, columns);
  columnsArranged = handleColumnsWidth(columnsArranged, columnsWidth, columns);

  return columnsArranged;
};
